<div class="w-full">
  <app-alert-modal class="font-tt-norms" [ngClass]="{ 'hidden': !isShowAlert }" [isSuccess]="isSuccess"  [message]="message" [buttonText]="buttonText"
    (closeModal)="closeModal()" (actionClick)="actionClick()"></app-alert-modal>
  <app-toast-notification [show]="showToast" [message]="toastMessage"></app-toast-notification>
  <div
    class="relative w-full md:w-auto m-auto min-h-[100dvh] md:min-h-[200px] px-6 py-8 md:px-12 md:py-12 md:h-auto md:absolute md:top-1/2 md:left-1/2 transform md:-translate-y-1/2 md:-translate-x-1/2 bg-white z-10 md:rounded-3xl transition-all duration-300"
    [ngClass]="{ 'md:px-8 md:py-8': service.currentStep() !== STEP.CELPHONE_NUMBER }">
    <div [ngClass]="service.currentStep() === STEP.SUCCESSQR ? 'flex items-center justify-center min-h-[100dvh] md:min-h-[200px]' : 'contents'">
      <ng-container [appStepOutlet]="steps[service.currentStep()]"></ng-container>
    </div>
  </div>
</div>
